import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS
} from '@angular/forms';

@Component({
    selector: 'email-list',
    template: `
        <textarea
            [value]="data"
            name="emailList"
            [placeholder]="placeholder"
            [disabled]="disabled"
            (change)="changed($event)"
            (keyup)="changed($event)"
        >
        </textarea>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: EmailListComponent,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: EmailListComponent,
            multi: true
        }
    ],
    standalone: false
})
export class EmailListComponent implements ControlValueAccessor {
    propagateChange: any = () => {};
    data = '';
    invalidEmailAdresses: string[] = [];

    @Input()
    placeholder: string;
    @Input()
    disabled = false;

    @Output()
    readonly onChange = new EventEmitter<any>();

    writeValue(value: any): void {
        if (value) {
            this.data = value;
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = (changed: any) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }

    changed(event: any) {
        // TODO: Use the Server Version of Regular Expression (Yet to figure this out)
        const emailRegularExp = /[^\s@]+@[^\s@]+\.[^\s@]+/;
        this.data = event.target.value;
        // Remove the spaces if any and create any array of emails
        const arr: string[] = this.data.split(' ').join('').split(',');
        this.invalidEmailAdresses = arr.filter(
            (email) => !emailRegularExp.test(email) && !!email
        );

        this.propagateChange(this.data);
        this.onChange.emit(this.data);
    }

    public validate() {
        let result: any = null;
        if (this.invalidEmailAdresses.length) {
            result = this.invalidEmailAdresses;
        }

        this.invalidEmailAdresses = [];
        return result;
    }
}
